import { createContext, useContext } from 'react';
import { useScreenSidebar } from './useScreenSidebar';
const Context = createContext({
    id: 'default',
    state: 'ready',
    areas: {
        sidebar: false,
    },
});
export const useScreenLayout = () => {
    const { id, state, areas } = useContext(Context);
    const sidebar = useScreenSidebar(id);
    return {
        id,
        sidebar,
        state,
        areas,
    };
};
export function ScreenLayoutProvider(props) {
    const { id, children, state, areas } = props;
    const value = {
        id,
        state,
        areas,
    };
    return <Context.Provider value={value}>{children}</Context.Provider>;
}
